function h(e, o, a) {
  const r = e.createShader(o);
  if (r) {
    if (e.shaderSource(r, a), e.compileShader(r), e.getShaderParameter(r, e.COMPILE_STATUS))
      return r;
    {
      const t = e.getShaderInfoLog(r);
      throw e.deleteShader(r), new Error("Failed to compile shader: " + t);
    }
  } else
    throw new Error("Failed to create shader");
}
function u(e, o, a) {
  const r = e.createProgram();
  if (r) {
    if (e.attachShader(r, o), e.attachShader(r, a), e.linkProgram(r), e.getProgramParameter(r, e.LINK_STATUS))
      return r;
    {
      const t = e.getProgramInfoLog(r);
      throw e.deleteProgram(r), new Error("Failed to link program: " + t);
    }
  } else
    throw new Error("Failed to create program");
}
function m(e, o, a, r, s) {
  const t = e.createBuffer();
  if (!t)
    throw new Error("Failed to create buffer");
  e.bindBuffer(e.ARRAY_BUFFER, t), e.bufferData(e.ARRAY_BUFFER, a, e.STATIC_DRAW);
  const n = e.FLOAT, i = !1, f = 0, d = 0, c = e.getAttribLocation(o, s);
  return e.vertexAttribPointer(
    c,
    r,
    n,
    i,
    f,
    d
  ), e.enableVertexAttribArray(c), t;
}
export {
  m as createBuffer,
  u as createProgram,
  h as createShader
};
//# sourceMappingURL=webgl2.js.map
